import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import { KHATTABAT_FUNNEL_STATS_HEADERS } from "../../../../constants/table-custom-headers/Khattabat";
import getSupervisorKhattabatStore from "../../../../stores/supervisor-store/supervisor-khattabat-store";

const FunnelStatsData = withLiteObserverAndTheme(() => {
  const funnelStatsStore = getSupervisorKhattabatStore();

  return (
    <Et3Table
      columns={KHATTABAT_FUNNEL_STATS_HEADERS}
      rows={funnelStatsStore.funnelStatsData.get()}
      title={i18n.get("SUPERVISOR_KHATTABAT_FUNNEL_STATS_DATA")}
      shouldBeFlagged={false}
      titleKey={"FUNNEL_STATS_DATA"}
    />
  );
});
export default FunnelStatsData;
